import { useMemo } from 'react';

import classNames from 'classnames';

import { DeserializedUserPublicProfile } from '@api';

import NextLink from '@shared/common/components/NextLink';
import ReadMoreText from '@shared/common/components/ReadMoreText';
import { useAuth } from '@shared/common/providers/AuthProvider';

import Avatar from '@store:web/components/common/Avatar/Avatar';

const UserInfo = ({
  data,
  isFullWithInfo,
}: {
  data: DeserializedUserPublicProfile;
  isFullWithInfo?: boolean;
}) => {
  const { user, isLoading } = useAuth();
  const isSameUser = useMemo(() => {
    return !isLoading && user?.attributes.name === data.attributes.magicId;
  }, [user, isLoading, data]);

  return (
    <div className="flex flex-col md:flex-row justify-center items-center md:items-start md:justify-between">
      <div className="flex gap-7 w-full flex-col md:flex-row justify-center md:justify-start items-center md:items-start">
        <Avatar
          userInfo={{
            magicId: data.attributes.magicId,
            displayName: data.attributes.displayName,
            membership: {
              tier: data?.membershipTier?.attributes?.key,
            },
          }}
          src={data.attributes.avatar}
          sizeInPX={125}
          containerClassName="rounded-full border-4 border-neutral-50 overflow-hidden"
        />

        <div
          className={classNames({
            'max-w-[400px]': !isFullWithInfo,
            'max-w-full md:max-w-[calc(100%_-_200px)]': isFullWithInfo,
          })}
        >
          <h1 className="t-h3 text-neutral-600 pb-2 truncate w-full">{data.attributes.magicId}</h1>
          <h2 className="t-h4 text-neutral-200 pb-2 truncate w-full">
            {data.attributes.displayName}
          </h2>

          <p className="text-sm font-light text-neutral-600">
            <ReadMoreText text={data.attributes.description || ''} />
          </p>
        </div>
      </div>

      {isSameUser && (
        <div className="flex w-full md:max-w-[150px] justify-end px-2 pt-6 md:px-2 md:pt-4">
          <NextLink
            className="button w-full button-primary button-lg font-semibold rounded-full mb-8 min-w-[150px] md:max-w-[150px]"
            href="/profile/settings"
          >
            Edit
          </NextLink>
        </div>
      )}
      <div></div>
    </div>
  );
};

export default UserInfo;
